import React, {useState, useEffect} from 'react'
import {Alerts} from '../component/notify'
import {ServerUrl, ImagesUrl, config, Token} from '../component/include'
import axios from 'axios'
import Cookies from 'js-cookie'
import {encrypt} from '../component/authentication'
import { Link } from 'react-router-dom'
import './login.css'
import './loading-overlay.css'

 const CentralLogin =()=> {

	const [notice, setNotice] = useState({
        isLoading : false,
        isDataFetching: false
	});
	
	const [showPassword, setShowPassword] = useState(false);

	const role = new URLSearchParams(window.location.search).get('role')
 

	const [user, setUser] = useState({
		email:'',
		password:'',
		remember:false,
		role: 'Admin', // Default role
		date:new Date().toISOString().slice(0,10),
		dateTime:new Date().toISOString().slice(0,19)
    })
    const [errors, setErrors] = useState({});

    const handleChange = event =>{		
        let {name, value} = event.target;	
        if(name==='remember'){
            value = !user.remember
        }	
       setUser({...user, [name] : value });
       setErrors({...errors, [name]:''});
    }
    
        	
	function submit(event){  
		event.preventDefault();

		if(navigator.onLine){
		setNotice({...notice, isLoading: true}) 	
           
        let formData = user;
        const fd = new FormData();
        for(let k in formData){
          fd.append(k, formData[k])
        }
           let url = ServerUrl+'/login_controller.php?tablename=tbl_login_user';
		axios.post(url, fd, config)
		.then(response =>{
	if (response.data.type ==='success'){
			
			//1000 * 60 * SESSION_IDEL_MINUTES
			var inSixtyMinutes = Date.now() + 419 * 60 * 1000;
			var inOneMinutes = Date.now() + 418 * 60 * 1000;
			  var inOneHours = new Date(new Date().getTime() + 419 * 60 * 1000);
			  
			  localStorage.setItem('_gaatexpt', inSixtyMinutes)
				localStorage.setItem('_gaatbexpt', inOneMinutes)
				Cookies.set('gaatkaustnm', encrypt(response.data.staffName), {expires: inOneHours })
			Cookies.set('gaatkauscd', encrypt(response.data.code), {expires: inOneHours })
			Cookies.set('gaatkagpcd', encrypt(response.data.groupId), {expires: inOneHours })
			Cookies.set('gaatkamtk', encrypt(response.data.jwt),  {expires: inOneHours })   
			Cookies.set('gaatkarfsh', encrypt(response.data.userToken),  {expires: inOneHours })

		
      // Set reset_password cookie - critical for password reset redirection
      Cookies.set('tkrspw', response.data.reset_password, {expires: inOneHours })
      
      // Set portal type and permissions
      Cookies.set('portal', user.role, {expires: inOneHours })
      Cookies.set('kayus_ed', response.data.allowEdit, {expires: inOneHours })
      Cookies.set('kayus_dt', response.data.allowDelete, {expires: inOneHours })
      
      // Set class and section IDs if available
      if(response.data.classID) {
        Cookies.set('clkysd', response.data.classID, {expires: inOneHours })
      }
      
      if(response.data.sectionID) {
        Cookies.set('sckayd', response.data.sectionID, {expires: inOneHours })
      }
      


if(user.role==='Staff'){
  localStorage.setItem('kayus_link', [])
}else{
  localStorage.setItem('kayus_link', encrypt(response.data.menuLink))
} 


			Alerts('Welcome!', 'success', response.data.message)
			
		//Anivikky@gmail.com

     if(response.data.reset_password ==='Yes'){

      window.open('/staff/my_password', '_self')

			}else{
        if(user.role==='Admin'){
          window.open('/startup', '_self')
        }else{
          window.open('/staffportal/dashboard', '_self')
        }
			}   


			}else if (response.data.type ==='error'){
				Alerts('Error!', 'info', response.data.message)
			}    
		})
		.catch((error)=>{
			Alerts('Error!', 'info', error.message)
			 
		}).finally(()=>{
            setNotice({...notice, 
				isLoading: false
			}) 
        })   
		
	 }else{
		Alerts('Error!', 'info', 'No internet connection')
	} 
 }



useEffect(()=>{

  if(role){
    setUser({...user, role})
  }

},[role])


 useEffect(()=>{  
	if(Token!==undefined){
		window.open('/dashboard', '_self')
		 } 
},[]);


        return (<>
         
          {notice.isLoading && (
            <div className="loading-overlay">
              <div className="loading-spinner">
                <div className="spinner-circle"></div>
                <div className="spinner-circle"></div>
                <div className="spinner-circle"></div>
                <div className="loading-text">Signing in...</div>
              </div>
            </div>
          )}
          
          <div className="login-container"  style={{background: `url(${ImagesUrl}/background/f.jpeg) `}} >
           
           
            <section className="login-wrapper">
              <div className="login-card">
                <div className="login-header">
                  <img src={`${ImagesUrl}/about/logo.png`} alt="KAYUS School" className="login-logo" />
                  <h2>Welcome Back</h2>
                  <p>Enter your email and password to login</p>
                 </div>
                
                <div className="login-body">
                  <form onSubmit={submit}>
                    <div className="form-group role-selector">
                      <label>Login As</label>
                      <div className="role-options">
                        <div className={`role-option ${user.role === 'Admin' ? 'active' : ''}`} onClick={() => setUser({...user, role: 'Admin'})}>                          
                          <i className="fa fa-user-shield"></i>
                          <span>Admin</span>
                        </div>
                        <div className={`role-option ${user.role === 'Staff' ? 'active' : ''}`} onClick={() => setUser({...user, role: 'Staff'})} >                          
                          <i className="fa fa-user"></i>
                          <span>Staff</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="email">Email Address</label>
                      <div className="">
                        
                        <input 
                          type="email" 
                          className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                          id="email" 
                          name="email" 
                          placeholder="Enter your email"
                          value={user.email}
                          onChange={handleChange}
                          required
                        />
                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                      </div>
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="password">Password</label>
                      <div className="password-input-container">
                        <input 
                          type={showPassword ? "text" : "password"} 
                          className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                          id="password" 
                          name="password" 
                          placeholder="Enter your password"
                          value={user.password}
                          onChange={handleChange}
                          required
                        />
                        <span 
                          className="password-toggle" 
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                        </span>
                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                      </div>
                    </div>
                    
                    <div className="form-group form-check" style={{marginLeft:'15px'}}>
                      <input 
                        type="checkbox" 
                        className="form-check-input" 
                        id="remember" 
                        name="remember"
                        checked={user.remember}
                        onChange={handleChange}
                      />
                      <label className="form-check-label" htmlFor="remember">Remember me</label>
                    </div>
                    
                    <button type="submit" className="btn btn-primary btn-block login-btn">
                      {notice.isLoading ? 'Signing In...' : 'Sign In'}
                    </button>
                  </form>
                </div>
                
                <div className="login-footer">
                  <p>
                    <Link to="/forgot_password" className="forgot-link">Forgot Password?</Link>
                  </p>
                  <p className="copyright">
                    &copy; {new Date().getFullYear()} KAYUS by Admotron Solutions
                  </p>
                </div>
              </div>
            </section>
          </div>
</> 

 );
        
}

export default React.memo(CentralLogin)  